import { useTranslation } from "react-i18next";
import * as yup from "yup";
import { isValidPhoneNumber } from "react-phone-number-input";

function useMerchantInscriptionValidationSchema(activityOptions) {
  const { t } = useTranslation("validationsSchema");

  const today = new Date();
  const legalAgeLimit = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());

  const schema = yup.object({
    firstName: yup.string().required(t("errorFirstName")),

    lastName: yup.string().required(t("errorLastName")),

    birthDate: yup.date().required(t("errorBirthDate")).max(legalAgeLimit, t("errorBirthDate")),

    email: yup.string().email(t("errorEmail")).required(t("errorEmail")),

    phoneNumber: yup
      .string()
      .required(t("errorPhoneNumber"))
      .test("valid-phone", t("errorPhoneNumber"), (value) => isValidPhoneNumber(value || "")),

    street: yup.string().required(t("errorStreet")),

    streetNumber: yup
      .string()
      .required(t("errorStreetNumber"))
      .matches(/^\d+(?:[\/\s]?[A-Za-z0-9]{1,5})?$/, t("errorStreetNumber")),

    city: yup.string().required(t("errorCity")),

    postalCode: yup
      .string()
      .required(t("errorPostalCode"))
      .matches(/^[1-9]{1}[0-9]{3}$/, t("errorPostalCode")),

    organizationName: yup.string().required(t("errorOrganizationName")),

    activitySector: yup
      .string()
      .oneOf(
        activityOptions.map((opt) => opt.value),
        t("errorActivitySector"),
      )
      .required(t("errorActivitySector")),

    websiteLink: yup.string().url(t("errorWebsiteLink")).required(t("errorWebsiteLink")),

    bankNumber: yup
      .string()
      .required(t("errorBankNumber"))
      .matches(/^BE\d{14}$/, t("errorBankNumber")),

    businessCategory: yup.string().required(t("errorBusinessCategory")),
  });

  return schema;
}

export default useMerchantInscriptionValidationSchema;
